/** Freeform text section — headline + body copy, no image or list
 * structure. The one block every custom page needs but no fixed page's
 * dedicated components cover: an FAQ page's intro blurb, a policy page's
 * body text, etc. Reusable across any admin-created custom page (see
 * `reusable: true` on its blockRegistry.js entry). */
export default function GenericRichText({ fields = {} }) {
  const { eyebrow, headline, body } = fields;

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        {eyebrow && (
          <p className="text-[#D4AF37] text-sm font-semibold tracking-widest uppercase mb-3">
            {eyebrow}
          </p>
        )}
        {headline && (
          <h2 className="text-white font-bold text-3xl sm:text-4xl mb-6 leading-tight">
            {headline}
          </h2>
        )}
        {body && (
          <div className="text-white/70 text-base leading-relaxed whitespace-pre-line">
            {body}
          </div>
        )}
      </div>
    </section>
  );
}
